import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Select, TextInput } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { getAllPlatformList } from '../../../../../services/platform'
import LoadingData from '../../../../ui/LoadingData'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const defaultVal = {
  store_name: '',
  order_number: '',
  platform_name: '',
  platform_shipping_courier: '',
  platform_tracking_number: '',
  platform_shipping_document: ''
}


const FormAdjustDropship = ({ onCloseForm }) => {
  const params = useParams()
  const orderId = params.order_id
  const { isLoadingOrder, general, dropship } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const [formData, setFormData] = useState(defaultVal)
  const [platformList, setPlatformList] = useState([])
  const [loadingPlatform, setLoadingPlatform] = useState(true)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitDropship = async (form) => {
    setLoadingForm(true)
    const payload = {
      order_infos: {
        billing: general.billingInformation,
        shipping: general.shippingInformation,
        order_number: form.order_number,
        platform: {
          name: form.platform_name ? form.platform_name : '',
          shipping_courier:  form.platform_shipping_courier,
          shipping_document:  form.platform_shipping_document,
          tracking_number:  form.platform_tracking_number
        },
        store_name: form.store_name,
      },
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetAllPlatform = async () => {
    setLoadingPlatform(true)
    try {
      const response = await getAllPlatformList()
      if (response.success) {
        const dataPlatform = response.data
        const remapData = dataPlatform.map((val) => {
          return {
            value: `${val.attributes.name}`,
            label: val.attributes.name.charAt(0).toUpperCase() + val.attributes.name.slice(1)
          }
        })
        setPlatformList(remapData)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingPlatform(false)
    }
  }

  useEffect(() => {
    handleGetAllPlatform()
    if (!isLoadingOrder) {
      handleSetForm(dropship)
    }
  }, [isLoadingOrder, dropship])

  const handleSetForm = (val) => {
    const detail = {
      store_name: val.senderName,
      order_number: val.orderNo,
      platform_name: val.platform.name,
      platform_shipping_courier: val.platform.shippingCourier,
      platform_tracking_number: val.platform.trackingNumber,
      platform_shipping_document: val.platform.trackingNumber
    }
    setFormData(detail)
  } 

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const loadData = () => {
    return (
      <Box>
        <Box mb='md'>
          <Select
            name='platform_name'
            value={formData.platform_name}
            label='Platform Name'
            data={platformList}
            onChange={(val) => handleChangeForm('platform_name', val)}
            size='xs'
            clearable
          />
        </Box>
        <Box mb='md'>
          <TextInput
            name='store_name'
            value={formData.store_name}
            label='Sender Name'
            placeholder='Input sender name'
            onChange={(val) => handleChangeForm('store_name', val.target.value)}
            size='xs'
          />
        </Box>
        <Box mb='md'>
          <TextInput
            name='order_number'
            value={formData.order_number}
            label='No. Order / Inv'
            placeholder='Input number order'
            onChange={(val) => handleChangeForm('order_number', val.target.value)}
            size='xs'
          />
        </Box>
        <Box mb='md'>
          <TextInput
            name='platform_shipping_courier'
            value={formData.platform_shipping_courier}
            label='Shipping Courier'
            placeholder='Input shipping courier'
            onChange={(val) => handleChangeForm('platform_shipping_courier', val.target.value)}
            size='xs'
          />
        </Box>
        <Box mb='md'>
          <TextInput
            name='platform_tracking_number'
            value={formData.platform_tracking_number}
            label='Tracking Number'
            placeholder='Input tracking number'
            onChange={(val) => handleChangeForm('platform_tracking_number', val.target.value)}
            size='xs'
          />
        </Box>
        <Box mb='md'>
          <TextInput
            name='platform_shipping_document'
            value={formData.platform_shipping_document}
            label='Shipping Document URL'
            placeholder='Input shipping document url'
            onChange={(val) => handleChangeForm('platform_shipping_document', val.target.value)}
            size='xs'
          />
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitDropship(formData)}>Update</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }
  
  return (
    <Box>
      {loadingPlatform ? <LoadingData /> : loadData()}
    </Box>
  )
}

export default FormAdjustDropship